import { Component, OnDestroy } from '@angular/core';
import { FormControl, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { ChangePasswordService } from './change-password.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { UtilService } from '@services/util.service';
import { AuthService } from 'src/app/auth';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss']
})
export class ChangePasswordComponent implements OnDestroy {
  public isLoading = false;
  public changePasswordForm: FormGroup = new FormGroup({
      newPassword: new FormControl(null, [Validators.required]),
      repeatNewPassword: new FormControl(null, [Validators.required])
    }, { validators: this.validatePassword() });
  public newPasswordVisible = false;
  public repeatNewPasswordVisible = false;
  private destroyed$: Subject<boolean> = new Subject<boolean>();

  constructor(
    public dialogRef: MatDialogRef<ChangePasswordComponent>,
    private changePasswordService: ChangePasswordService,
    private utilService: UtilService,
    private authService: AuthService,
  ) { }

  ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  public closeDialog(): void {
    this.dialogRef.close();
  }

  private validatePassword(): ValidatorFn {
    return () => {
      const newPassword = this.changePasswordForm?.get('newPassword').value;
      const repeatNewPassword = this.changePasswordForm?.get('repeatNewPassword').value;
      if (!newPassword || !repeatNewPassword) {
        return null;
      } else if (!/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/.test(newPassword) ||
        !/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/.test(repeatNewPassword)
      ) {
        return { format: true };
      } else {
        return newPassword === repeatNewPassword ? null : { 'notMatch': true };
      }
    };
  }

  public onSubmit(): void {
    this.isLoading = true;
    this.changePasswordService.changePassword({
      password: this.changePasswordForm.get('newPassword').value,
      confirmPassword: this.changePasswordForm.get('repeatNewPassword').value
    }).pipe(takeUntil(this.destroyed$)).subscribe(result => {
      if (result.success) {
        this.authService.logout();
        this.closeDialog();
      } else {
        this.utilService.toastErrors(result);
      }
      this.isLoading = false;
    }, (error) => {
      this.isLoading = false;
      this.utilService.toastErrors(error);
    });
  }
}
